var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0003 13.4586C24.0318 13.4586 12.667 24.4164 12.667 37.8871C12.667 51.3579 24.0318 62.3157 38.0003 62.3157C51.9689 62.3157 63.3337 51.3579 63.3337 37.8871C63.3337 24.4164 51.9689 13.4586 38.0003 13.4586ZM30.3364 49.6065L35.286 54.6014L51.2177 37.8489L30.3364 49.6065Z",
    fill: "#093863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.8316C18.7234 3.8316 3.04004 19.5134 3.04004 38.7916C3.04004 58.0698 18.7234 73.7516 38 73.7516C57.2767 73.7516 72.96 58.0698 72.96 38.7916C72.96 19.5134 57.2767 3.8316 38 3.8316ZM27.4239 55.5633L27.2977 22.1294L56.24 38.7369L27.4239 55.5633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.8b4704b02dc5aa4b309f165a1daf22f0.svg";
export { ForwardRef as ReactComponent };